<div class="container-fluid" style="margin-top:70px;">
  <div class="row">
    <div class="col-xl-12 col-lg-12 col-sm-12 col-xs-12 xl-12">
      <div class="card" style="margin-bottom:50px;">
        <div class="card-body">
          <p>SEND CRASH REPORT</p>
          <p>
            <mat-progress-bar [style.display]="isFullyLoaded2 ? 'none' : 'block'" mode="indeterminate"></mat-progress-bar>
          </p>
          <small>
            Perhaps, you could not find a solution to a problem you encountered from the FAQ section above,
            Send a crash report to the technical team and a response will be sent to you soon.
            A crash report can be sent by filling the form below. To properly and effectively
            describe the situation, you can include a screenshot. Maximum size is 100kb.
          </small>
          <form (ngSubmit)="sendCrashReport(myForm.value)" [formGroup]="myForm">
            <div class="form-group">
              <label>Subject: </label>
              <input type="text" class="form-control" name="subject" formControlName="subject" required />
              <span *ngIf="!myForm.controls['subject'].valid &&
              myForm.controls['subject'].touched"><small>*Required</small></span>
            </div>

            <div class="form-group">
              <label>Crash Report: </label>
              <textarea type="text" class="form-control" name="message" formControlName="message" rows="4" required></textarea>
              <span *ngIf="!myForm.controls['subject'].valid &&
              myForm.controls['subject'].touched"><small>*Required</small></span>
            </div>

            <div class="form-group">
              <input #fileInput mat-button type="file" style="display:none" name="images" formControlName="images"
                (change)="uploadImages($event.target.files)">
              <button mat-button type="button" style="background-color:#999;" class="mr-3" (click)="fileInput.click()">Upload
                Images</button><br />
              <span><small style="color:#ff0000;">{{errMessage}}</small></span>
            </div>

            <div class="form-group">
              <button type="submit" mat-button style="background-color:#20273B;color:#fff;" [disabled]="!myForm.valid">Send</button>
            </div>
          </form>

        </div>
      </div>
    </div>
  </div>
</div>